export const UserRole = {
  Admin: 'Admin',
  JA:'JA',
  Buyer: 'Buyer',
  Seller: 'Seller',
  Farmer: 'Farmer',
} as const;

export type UserRole = typeof UserRole[keyof typeof UserRole];